import React from "react";

export const Integrations = ({ ui }) => {
  return (
    <div id="integrations" className="integrations-section">
      <div className="container integrations-container">
        <div className="text-center col-md-8 col-md-offset-2">
          <div className="section-title integrations-title-wrap">
            <h2 className="integrations-title">{ui?.title}</h2>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="integration-text">
              <h3 className="integrations-subtitle">{ui?.subtitle}</h3>
              <p>{ui?.intro}</p>
              <ol className="integrations-steps">
                {ui?.steps?.map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ol>
              <p>{ui?.alpha}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
